import React from 'react';
import Iframe from 'react-iframe'
import { ReactComponent as Logo } from '../images/logo.svg';

const Document = (props) => {

    return (
        <div className="row">
            <div className="col-12">
                <div className="page-logo">
                    <Logo />
                </div>
            </div>
            <div className="col-12">
                <h1 className="page-title extra-space">Documents</h1>

                <Iframe 
                    url="https://www.djmir.com.au/documents" 
                    width="100%" 
                    height="100%" 
                    // styles={{height: "100vh"}}
                />
            </div>
        </div>
    )
}

export default Document;